<dx-data-grid #dataGrid
  [dataSource]="tarifsFret"
  [allowColumnReordering]="true"
  [columnAutoWidth]="true"
  [allowColumnResizing]="true"
  [showBorders]="true"
  noDataText="Aucun tarifs fret personnalisés trouvés"
  height="750px"

  (onRowInserting)="onRowInserting($event.data)"
  (onRowUpdating)="onRowUpdating($event)"
  (onRowRemoving)="onRowRemoving($event.data)"
  (onSelectionChanged)="onSelectionChanged($event)"
>
  <!-- #region Toolbar -->
  <dxo-toolbar>
    <dxi-item location="before">
      <div class="header-text">Tarifs fret personnalisés</div>
    </dxi-item>
    <dxi-item location="before">
      <div *dxTemplate>
        <dx-button [text]="tarifsFret?.length > 0 ? 'Réinitialiser les tarifs fret' : 'Initialiser les tarifs fret'"
          type="default" stylingMode="contained"
          [disabled]="disabled"
          (onClick)="reinitialiserTarifsFret()"
        ></dx-button>
      </div>
    </dxi-item>
    <dxi-item location="before">
      <div *dxTemplate style="margin-left: 6px;">
        <dx-button text="Modifier les lignes sélectionnées" type="default" stylingMode="contained"
          (onClick)="onOpenPopup()"
          [disabled]="disabled || selectedRows?.length < 2"
        ></dx-button>
      </div>
    </dxi-item>
    <dxi-item location="after">
      <div *dxTemplate>
        <dx-button icon="refresh" stylingMode="text" hint="Rafraîchir" (onClick)="setDataSource()"></dx-button>
      </div>
    </dxi-item>
    <dxi-item name="addRowButton"></dxi-item>
    <dxi-item name="revertButton"></dxi-item>
    <dxi-item name="saveButton"></dxi-item>
    <dxi-item location="after">
      <div *dxTemplate>
        <app-reset-grid-state [dataGrid]="dataGrid"></app-reset-grid-state>
      </div>
    </dxi-item>
    <dxi-item name="columnChooserButton"></dxi-item>
  </dxo-toolbar>
  <!-- #endregion -->

  <!-- #region Options -->
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-header-filter [visible]="true">
    <dxo-search [enabled]="true"></dxo-search>
  </dxo-header-filter>
  <dxo-column-chooser [enabled]="true" mode="select" [height]="600"></dxo-column-chooser>
  <dxo-paging [enabled]="true" [pageSize]="50"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[50, 100, 150]" [showInfo]="true" [visible]="true"
    [infoText]="getTexteLignesSelectionees() + ' | Page {0} sur {1} ({2} éléments)'"
  ></dxo-pager>
  <dxo-selection mode="multiple"></dxo-selection>
  <dxo-remote-operations [sorting]="true" [filtering]="true" [paging]="true"></dxo-remote-operations>
  <dxo-editing mode="batch" [allowUpdating]="!disabled" [allowAdding]="!disabled" [allowDeleting]="!disabled" [selectTextOnEditStart]="true"></dxo-editing>
  <!-- #endregion -->

  <!-- #region Colonnes -->
  <dxi-column dataField="typeFretId" caption="Tarif Revatua" alignment="left" [allowEditing]="false">
    <dxo-lookup [dataSource]="typesFret" valueExpr="id" displayExpr="tarifRevatuaIntitule"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="ileDepartId" caption="Île de départ" alignment="left">
    <dxo-lookup [dataSource]="dataSourceIles" displayExpr="libelle" valueExpr="id"></dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="ileArriveeId" caption="Île d'arrivée" alignment="left">
    <dxo-lookup [dataSource]="dataSourceIles" displayExpr="libelle" valueExpr="id"></dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="typeTarifFret" caption="Mode de calcul" alignment="left">
    <dxi-validation-rule type="required"></dxi-validation-rule>
    <dxo-lookup [dataSource]="typesTarifsFret" valueExpr="id" displayExpr="intitule"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="montant" caption="Montant" alignment="left" [width]="180" [format]="{ style: 'currency', currency: 'XPF' }">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <!-- #endregion -->
</dx-data-grid>

<dx-popup
  [showCloseButton]="true"
  title="Modification groupée"
  [(visible)]="showPopup"
  [width]="400"
  [height]="320"
>
  <div *dxTemplate="let data of 'content'">
    <p>Vous êtes sur le point de modifier {{ selectedRows?.length }} lignes.</p>
    <dx-form #form [formData]="formData">
      <dxi-item dataField="montant" [label]="{text: 'Montant'}" editorType="dxNumberBox"
        [editorOptions]="{ format: { style: 'currency', currency: 'XPF' } }"
      >
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>
      <dxi-item dataField="typeTarifFret" [label]="{text: 'Mode de calcul'}" editorType="dxSelectBox"
        [editorOptions]="{ items: typesTarifsFret, displayExpr: 'intitule', valueExpr: 'id' }"
      >
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>
    </dx-form>
  </div>

  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
    [options]="{
      text: 'Annuler',
      stylingMode: 'contained',
      onClick: onCancelPopup
    }"
  ></dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
    [options]="{
      text: 'Enregistrer',
      type: 'default',
      stylingMode: 'contained',
      onClick: onSavePopup
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>